import ChessLink from './ChessLink';

export default ChessLink;



// WEBPACK FOOTER //
// ./src/components/Building/Main/ChessLink/index.js